// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__wCtxw","employee-header-item":"Header_employee-header-item__1AT0Z"};